import { Route, Navigate, Routes } from "react-router-dom";
import RouteGuard from "./RouteGuard";
import DashBoard from "../pages/DashBoard";
import PanelLayout from "../layouts/PanelLayout";
import PageNotFound from "../pages/PageNotFound";
import PanLookup from "../pages/industry/PanLookup";
import Organization from "../pages/Reports/ORG/Organization";
import Approach from "../pages/Reports/NOLOAN/Approach";
import CollectionFirst from "../pages/Reports/Collection/CollectionFirst";

const protectedRoutes = (
  <Route element={<RouteGuard />}>
            <Route path="*" element={<PageNotFound />} />

        <Route element={<PanelLayout />}>
            <Route
                path="/dashboard"
                element={ <DashBoard /> }
            />

            <Route
                path="/reports/org"
                element={ <Organization /> }
            />

            <Route
                path="/reports/CollectionReport"
                element={ <CollectionFirst /> }
            />

             <Route
                path="/reports/noloan"
                element={ <Approach /> }
            />

            <Route
                path="/panlookup/:panno"
                element={ <PanLookup /> }
            />


             <Route
                path="/reports/EmployeeReport"
                element={ <Organization /> }
            />

            {/* <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/leads" element={<Leads />} /> */}
        </Route>
  </Route>
);

export default protectedRoutes;
